module.exports = __webpack_public_path__ + "img/property.6d1e2fc6.svg";